import type { HelpFile } from '../../types/help'
import { SchemaViolationsTestIds } from '../../../testids/SchemaViolationsTestIds'

export const schemaViolationsHelp: HelpFile = {
  docPage: '/docs/schema/violations',
  texts: {
    [SchemaViolationsTestIds.schemaViolationsList]:
      'Schema policy violations — drift surfaced by the substrate. Each row links the affected entity and identifies the policy that fired.',
    [SchemaViolationsTestIds.colPolicy]: 'The schema policy whose expression evaluated to false for this row.',
    [SchemaViolationsTestIds.colDetectedAt]: 'When the violation was first detected.',
    [SchemaViolationsTestIds.colSeverity]: 'Severity declared on the policy — INFO, WARN, ERROR, or CRITICAL.',
    [SchemaViolationsTestIds.colStatus]: 'OPEN until acknowledged; ACKED when an admin has acknowledged; RESOLVED when the underlying drift was fixed.',
    [SchemaViolationsTestIds.colMessage]: 'Violation message rendered from the policy template — usually identifies the affected entity by display name.',
    [SchemaViolationsTestIds.colActions]: 'Per-row actions — acknowledge a single violation.',
    [SchemaViolationsTestIds.colSelect]: 'Toggle row selection for bulk-acknowledge.',
    [SchemaViolationsTestIds.checkboxToggleAll]: 'Toggle selection of all visible rows.',
    [SchemaViolationsTestIds.btnBulkAck]: 'Acknowledge every selected OPEN violation in one call.',
  },
}
